<template>
  <v-text-field
    v-model="computedValue"
    class="closd-text-field"
    :class="{
      'closd-text-field--small': small,
    }"
    :color="color"
    :hide-details="hideDetails"
    clear-icon="fal fa-xmark"
    density="compact"
    ref="input"
    variant="outlined"
    v-bind="$attrs"
    @click:clear="clear"
  >
    <template v-for="(_, slot) in $slots" v-slot:[slot]>
      <slot :name="slot" />
    </template>
  </v-text-field>
</template>

<script>
/**
 * A wrapper around the text field with default styling and custom default behavior
 * All Vuetify props for the text field component are usable.
 * @see https://vuetifyjs.com/en/api/v-text-field/#props
 */
export default {
  name: 'AppTextField',
  inheritAttrs: false,
  emits: [
    'clear',
    'update:model-value',
  ],
  props: {
    /**
     * @model
     * The input’s value
     */
    modelValue: {
      required: true,
    },
    /**
     * Applies specified color to the control
     * @default blue darken-2
     */
    color: {
      default: 'blue-darken-2',
    },
    /**
     * Hides hint and validation errors
     */
    hideDetails: {
      default: 'auto',
    },
    small: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    computedValue: {
      get () {
        return this.modelValue
      },
      set (newValue) {
        /**
         * The updated bound model
         *
         * @property {string} newValue new value set
         */
        this.$emit('update:model-value', newValue)
      },
    },
  },
  methods: {
    clear () {
      this.$emit('clear')
    },
  },
}
</script>

<style scoped lang="scss">
.closd-text-field.closd-text-field--small {
  min-width: 60px;
  :deep(.v-field__input) {
    min-height: 28px;
    padding-top: 3px;
  }

  :deep(.v-field__field) {
    height: 28px;
  }
}

:deep(.v-field__input::placeholder) {
  color: rgb(var(--v-theme-grey-500)) !important;
  opacity: 1;
}
</style>
